/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EPlayerType } from "../types/EPlayerType.ts";

/**
 * @description 1 = Vimeo | 2 = YouTube | 3 = JWPlayer | 4 = Others |
 */
export const ePlayerTypeSchema = z
  .union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)])
  .describe(
    "1 = Vimeo | 2 = YouTube | 3 = JWPlayer | 4 = Others | ",
  ) as unknown as ToZod<EPlayerType>;
